import { TrackingItem } from 'src/schema'

export const getFilteredAndRenamedOrderTracking = (tracking: TrackingItem[]) =>
  tracking
    .filter((item) => item.statusId !== TrackingItem.statusId.CANCEL)
    .map((item) => {
      let newStatusName = item.statusName

      switch (item.statusId) {
        case TrackingItem.statusId.DEPARTURE_TERMINAL:
          newStatusName = 'Посылка готова к отправке из магазина'
          break
        case TrackingItem.statusId.TRANSIT:
          newStatusName = 'Перевозка'
          break
        case TrackingItem.statusId.DESTINATION_TERMINAL:
          newStatusName = 'Посылка прибыла в магазин'
          break
        case TrackingItem.statusId.DELIVERED:
          newStatusName = 'Исполнена'
          break
      }

      return {
        ...item,
        statusName: newStatusName
      }
    })
